<template>
  <div v-loading.lock="loading">
    <el-row>
      <el-row>
        <br>
        <el-col :span="24">
          <el-form :inline="true"
                   class="demo-form-inline">
            <el-form-item label="股票选择">
              <el-select @focus="showSearchLogs"
                         @change="getSearchLogs"
                         v-model="stockCode"
                         value-key="ts_code"
                         filterable
                         remote
                         :remote-method="searchStock"
                         default-first-option
                         placeholder="请输入股票名称或股票代码">
                <el-option-group :label="searchLabel">
                  <el-option v-for="(item,index) in options"
                             :key="index"
                             :label="item.name"
                             :value="item.symbol">
                  </el-option>
                </el-option-group>
              </el-select>

            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="openTypeDialog(stockCode,'普通搜索')">分析一下</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="selectDialogVisible=!selectDialogVisible">高级搜索&nbsp;&nbsp;<i class="iconfont"
                   style="font-size:5px!important;color:#aaa">
                  <template v-if="selectDialogVisible">
                    &#xee10;
                  </template>
                  <template v-else>
                    &#xe60f;
                  </template>
                </i></el-button>
            </el-form-item>
          </el-form>

        </el-col>
        <el-col :span="24"
                v-if="selectDialogVisible">

          <el-form :model="selectForm"
                   :inline="true">
            <el-row>

              <el-form-item label="行业">
                <el-select clearable
                           @change="searchStockBySelect(1)"
                           v-model="selectForm.industry"
                           filterable
                           placeholder="请选择">
                  <el-option v-for="item in searchIndustryList"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="概念">
                <el-select clearable
                           @change="searchStockBySelect(1)"
                           v-model="selectForm.concept"
                           filterable
                           placeholder="请选择">
                  <el-option v-for="item in searchConceptList"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>

              </el-form-item>

              <el-form-item label="企业性质">
                <el-select clearable
                           @change="searchStockBySelect(1)"
                           v-model="selectForm.companyType"
                           filterable
                           placeholder="请选择">
                  <el-option v-for="item in searchCompanyTypeList"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="地区">
                <el-select clearable
                           @change="searchStockBySelect(1)"
                           v-model="selectForm.location"
                           filterable
                           placeholder="请选择">
                  <el-option v-for="item in searchLocationList"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-row>
            <el-row>
              <el-table :data="searchStocks"
                        style="width: 100%">
                <span slot="empty">
                  <div style="line-height:20px;">
                    <br>
                    <img src="../../assets/imgs/emptyTable.png" />
                    <div v-if="selectForm.industry || selectForm.concept || selectForm.companyType || selectForm.location"> 暂无搜索记录！</div>
                    <div v-else>请设置搜索条件！</div>
                    <br>
                  </div>
                </span>
                <el-table-column prop="short_name"
                                 label="股票">
                </el-table-column>
                <el-table-column prop="industry_name"
                                 label="行业">
                </el-table-column>
                <el-table-column prop="bk_name"
                                 label="概念">
                </el-table-column>
                <el-table-column prop="location"
                                 label="地区">
                </el-table-column>
                <el-table-column prop="nature"
                                 label="企业性质">
                </el-table-column>
                <el-table-column label="操作"
                                 width="100">
                  <template slot-scope="scope">
                    <el-button @click="openTypeDialog(scope.row.symbol,'高级搜索')"
                               type="text"
                               size="small">生成报告</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <br>
            </el-row>

            <el-row v-if="searchStocks && selectForm.total > 10 ">

              <el-pagination background
                             :small=true
                             @current-change="searchStockBySelect"
                             :currentPage="selectForm.page"
                             layout="prev, pager, next"
                             :total="selectForm.total">
              </el-pagination>
              <br>
            </el-row>
          </el-form>
        </el-col>
      </el-row>

      <el-row style="height:calc( 100vh - 370px );overflow-y:scroll">
        <br>
        <el-col :span="14">
          <h3 style="text-align:left">
            财务能力TOP10
          </h3>

        </el-col>
        <el-col :span="10"
                style="text-align:right">
          <div style="clear:both;height:25px"></div>
          <span style="color:#888;font-size:0.8em">财务周期:&nbsp; {{financeScore.date[selectDate]}}</span>
        </el-col>

        <el-col :span="24">
          <br>
          <el-tabs type="card"
                   v-model="activeTab">
            <el-tab-pane v-for="(k,v) in financeScore.comment"
                         :key="k"
                         :label="k"
                         :name="v">
              <el-table :data="financeScore.data[selectDate].scores[v]"
                        width="100">

                <el-table-column label="股票"
                                 prop="name">
                </el-table-column>

                <el-table-column label="评分">
                  <template slot-scope="scope">
                    {{parseFloat(scope.row[v]).toFixed(2)}}
                  </template>
                </el-table-column>
                <el-table-column label="ROA"
                                 prop="roa">
                </el-table-column>
                <el-table-column label="流动比率"
                                 prop="current">
                </el-table-column>
                <el-table-column label="净现比"
                                 prop="cashratio">
                </el-table-column>
                <el-table-column label="净利润增长率(环比)"
                                 prop="growth">
                </el-table-column>
                <el-table-column label="发布日期">
                  <template slot-scope="scope">
                    {{scope.row.report_date}}

                  </template>
                </el-table-column>

                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button @click="openTypeDialog(scope.row.symbol,'财务能力TOP10-'+k)"
                               type="text"
                               size="small">生成报告</el-button>
                  </template>
                </el-table-column>
              </el-table>

            </el-tab-pane>
          </el-tabs>

        </el-col>

        <el-col :span="24">
          <br>
          <el-col :span="24">
            <h3 style="text-align:left">
              近期发布财报公司
            </h3>
            <el-table :data="recentFinance.data"
                      width="100">

              <el-table-column label="股票"
                               prop="name">
              </el-table-column>
              <el-table-column label="ROA"
                               prop="roa">
              </el-table-column>
              <el-table-column label="流动比率"
                               prop="current">
              </el-table-column>
              <el-table-column label="净现比"
                               prop="cashratio">
              </el-table-column>
              <el-table-column label="净利润增长率(环比)"
                               prop="growth">
              </el-table-column>
              <el-table-column label="报告期"
                               prop="type">
              </el-table-column>

              <el-table-column label="发布日期"
                               prop="date">
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button @click="openTypeDialog(scope.row.symbol,' 最新上市公司财报TOP10')"
                             type="text"
                             size="small">生成报告</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-row style="text-align:center">
              <br>
              <el-pagination background
                             @current-change="getRecentFinanceList"
                             layout="prev, pager, next"
                             :total="500">
              </el-pagination>
            </el-row>
          </el-col>

        </el-col>
      </el-row>

    </el-row>

    <!--类型选择框-->
    <el-dialog width="500px"
               :visible.sync="typeDialogVisible">
      <div class="c_p"
           slot="title"><b>{{(stockName)||'财报分析'}}</b></div>
      <el-form>

        <el-form-item label="文件类型">
          <template>

            <el-radio v-model="fileType"
                      label="PDF">PDF</el-radio>
            <el-radio v-model="fileType"
                      label="DOC">word</el-radio>
          </template>
        </el-form-item>
        <GenDialog />
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="typeDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="checkStock">生 成</el-button>
      </div>
    </el-dialog>

    <el-dialog width="500"
               top="0"
               :close-on-click-modal=false
               :visible.sync="pdfDialogVisible">
      <iframe :src="pdfUrl+'#toolbar=0'"
              title=""
              style="width: 100%; height: calc(100vh - 120px);border: 0;" />
      <div style="text-align:center">
        <el-button @click="toDownPdf()"
                   size="small">下载</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import GenDialog from './GenDialog.vue'
export default {
  name: 'finance',
  data () {
    return {
      financeScore: {},
      recentFinance: {},
      searchLabel: '搜索历史',
      selectDate: '',
      activeTab: '',
      options: [],
      curStock: {},
      stockCode: '',
      stockName: '',
      candidateOptions: [],
      typeDialogVisible: false,
      selectDialogVisible: false,
      searchIndustryList: [],
      searchCompanyTypeList: [],
      searchLocationList: [],
      searchConceptList: [],
      searchStocks: [],
      selectForm: {},
      fileType: 'PDF',
      loading: true,
      pdfDialogVisible: false,
      pdfUrl: '',
      reportId: ''
    }
  },
  computed: {
    payResult: function () {
      return this.$store.state.payResult
    }
  },
  watch: {
    payResult: function () {
      this.reportId = this.$store.state.payData.id
      if (this.reportId) {
        this.getReportStatus()
      }
    },
    activeTab: function () {
      // eslint-disable-next-line no-undef
      _hmt.push(['_trackEvent', '财务能力TOP10页签', this.activeTab])
    }
  },
  mounted: function () {
    let _this = this

    try {
      this.candidateOptions = JSON.parse(localStorage.getItem('candidateOptions'))
      this.financeScore = JSON.parse(localStorage.getItem('financeScore') || '{}')
      for (let k in this.financeScore.date) {
        this.selectDate = k
        break
      }
      for (let k in this.financeScore.comment) {
        this.activeTab = k
        break
      }
    } catch (e) { }
    axios.get('/api/web/stock/list').then(resp => {
      _this.candidateOptions = resp.data
      localStorage.setItem('candidateOptions', JSON.stringify(_this.candidateOptions))
      _this.loading = false
    })

    axios.get('/api/web/stock/financeScoreList/').then(resp => {
      _this.financeScore = JSON.parse(resp.data)
      localStorage.setItem('financeScore', JSON.stringify(_this.financeScore))
      for (let k in _this.financeScore.date) {
        _this.selectDate = k
        break
      }
      for (let k in _this.financeScore.comment) {
        _this.activeTab = k
        break
      }
    })

    this.getSearchLogs()
    this.getRecentFinanceList()

    axios.get('/api/web/stock/industryList').then(resp => {
      _this.searchIndustryList = resp.data && JSON.parse(resp.data) &&
        JSON.parse(resp.data).data &&
        JSON.parse(resp.data).data.industrySearch &&
        JSON.parse(JSON.parse(resp.data).data.industrySearch.result)
    })

    axios.get('/api/web/stock/companyTypeList').then(resp => {
      _this.searchCompanyTypeList = resp.data && JSON.parse(resp.data) &&
        JSON.parse(resp.data).data &&
        JSON.parse(resp.data).data.natureSearch &&
        JSON.parse(JSON.parse(resp.data).data.natureSearch.result)
    })

    axios.get('/api/web/stock/locationList').then(resp => {
      _this.searchLocationList = resp.data && JSON.parse(resp.data) &&
        JSON.parse(resp.data).data &&
        JSON.parse(resp.data).data.locationSearch &&
        JSON.parse(JSON.parse(resp.data).data.locationSearch.result)
    })

    axios.get('/api/web/stock/conceptList').then(resp => {
      _this.searchConceptList = resp.data && JSON.parse(resp.data) &&
        JSON.parse(resp.data).data &&
        JSON.parse(resp.data).data.conceptSearch &&
        JSON.parse(JSON.parse(resp.data).data.conceptSearch.result)
    })
  },

  methods: {
    getRecentFinanceList (page) {
      if (!page) {
        page = 1
      }
      let _this = this
      axios.get('/api/web/stock/recentFinanceList?page=' + page).then(resp => {
        _this.recentFinance = resp.data
      })
    },
    searchStockBySelect (p) {
      this.selectForm.page = p
      let _this = this
      if (!this.selectForm.location &&
        !this.selectForm.companyType &&
        !this.selectForm.concept &&
        !this.selectForm.industry) {
        _this.searchStocks = []
        _this.selectForm.total = 0
        return
      }
      axios.post('/api/web/stock/stockSearchList', this.selectForm).then(resp => {
        _this.searchStocks = resp.data.records
        _this.selectForm.total = parseInt(resp.data.total)
      })
    },
    checkStock () {
      let _this = this
      this.typeDialogVisible = false
      axios.get('/api/web/stock/checkStock/FINANCE/' + this.stockCode).then(resp => {
        var checkRes = resp.data
        var msg = ''
        for (var i = 0; i < checkRes.length; i++) {
          var temp = checkRes[i]
          switch (temp.list_status) {
            case 'L':
              console.log('正常')
              break
            case 'D':
              msg = msg + '股票【' + temp.short_name + '】已退市'
              console.log('退市')
              break
            case 'WD':
              msg = msg + '股票【' + temp.short_name + '】已退市整理'
              console.log('退市整理')
              break
            case 'ST':
              msg = msg + '股票【' + temp.short_name + '】已被证监会警告处理'
              console.log('证监会警告处理')
              break
            case 'ST* PT':
              msg = msg + '股票【' + temp.short_name + '】已被证监会警告处理'
              console.log('证监会警告处理')
              break
            case 'N':
              msg = msg + '股票【' + temp.short_name + '】为新股'
              console.log('新股')
              break
            case 'SN':
              msg = msg + '股票【' + temp.short_name + '】为次新股'
              console.log('次新股')
              break
            case 'PT':
              msg = msg + '股票【' + temp.short_name + '】等待退市'
              console.log('等待退市')
              break
            case 'P':
              msg = msg + '股票【' + temp.short_name + '】已暂停上市'
              console.log('暂停上市')
              break
          }
        }
        if (msg) { // 有不正常的股票
          msg = msg + ',报告数据可能缺失，是否继续生成？'
          this.$confirm(msg, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            _this.genPdf()
          })
        } else {
          _this.genPdf()
        }
      })
    },
    genPdf () {
      let _this = this
      this.loading = true
      axios.get('/api/web/stock/genReport/' + this.fileType + '/FINANCE/' + this.stockCode).then(resp => {
        _this.pdfUrl = ''
        this.reportId = resp.data.id
        _this.$store.commit('toFreshUserPrice')
        _this.getReportStatus()
      }).catch(e => {
        _this.loading = false
        if (e.code === 401) {
          _this.$alert(e.msg, '您的使用次数已超过限制!')
        }
      })
    },
    getReportStatus () {
      let _this = this
      axios.get('/api/web/stock/reportInfo/' + _this.reportId).then(resp => {
        _this.loading = true
        if (resp.data.status === 'DOING') {
          setTimeout(() => {
            _this.getReportStatus(_this.reportId)
          }, 2000)
        } else if (resp.data.status === 'FINISH') {
          _this.loading = false
          _this.sourceId = resp.data.sourceId
          if (resp.data.fileType === 'PDF') {
            _this.pdfDialogVisible = true
            _this.pdfUrl = '/api/web/stock/readPdf/' + this.sourceId
            _this.pdfDialogVisible = true
          } else {
            _this.toDownPdf()
          }
        } else {
          _this.loading = false
          _this.$notify.error({
            title: '失败',
            message: '报告生成失败，请稍候重试。'
          })
        }
      })
    },
    toDownPdf () {
      window.open('/api/web/stock/downLoadReport/' + this.sourceId)
    },
    openTypeDialog (code, source) {
      if (!code) {
        this.$message.error('请选择股票')
        return
      }
      if (source) {
        // eslint-disable-next-line no-undef
        _hmt.push(['_trackEvent', '生成财务报告来源', source])
      }

      let _this = this
      _this.options = this.candidateOptions
      this.candidateOptions.forEach(i => {
        if (i.ts_code.indexOf(code) > -1) {
          _this.stockName = i.name
        }
      })

      this.stockCode = code
      this.typeDialogVisible = true
    },
    showSearchLogs () {
      this.searchLabel = '搜索历史'
      this.options = this.searchLogs
    },
    getSearchLogs (item) {
      let url = '/api/web/stock/searchLogs'
      if (item && item.ts_code) {
        url = url + '?code=' + item.ts_code
      }
      let _this = this
      axios.get(url).then(resp => {
        _this.searchLogs = resp.data
      })
    },
    searchStock (query) {
      query = query.trim()
      if (query) {
        this.searchLabel = '搜索结果'
        let _this = this
        setTimeout(() => {
          _this.options = _this.candidateOptions.filter(item => {
            return ((item.name.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
              (item.ts_code.toLowerCase().indexOf(query.toLowerCase()) > -1) ||
              ((item.pinyin || '').toLowerCase().indexOf(query.toLowerCase()) > -1)
            )
          })
        }, 200)
      } else {
        this.options = this.searchLogs
      }
    }
  },
  components: {
    GenDialog
  }

}
</script>
<style >
</style>



// WEBPACK FOOTER //
// src/components/index/finance.vue